import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

interface IContainerMenuOptions {
  sideMenuIsClose: boolean;
}

export const ContainerMenuOptions = styled.div<IContainerMenuOptions>`
  padding: 1rem 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  transition: 0.3s all;
  ::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .menu-logo-container {
    width: 100%;
    display: ${({ sideMenuIsClose }) => (sideMenuIsClose ? 'none' : 'flex')};
    flex-direction: column;
    align-items: center;
    margin: 10px 0 20px;
    img {
      width: 60%;
      height: auto;
      max-width: 180px;
    }
  }

  .menu-version {
    margin-top: 0.5rem;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.7rem;
    color: ${({ theme }) => transparentize(0.4, theme.COLORS.WHITE)};
    text-align: center;
  }

  .option-separator {
    width: 96%;
    align-self: center;
    margin: 0.2rem auto;
    border-radius: 8px;
    border-top: 0.2px solid
      ${({ theme }) => transparentize(0.7, theme.COLORS.GREEN_20)};
    display: flex;
    justify-content: ${({ sideMenuIsClose }) =>
      sideMenuIsClose ? 'center' : 'space-between'};
    align-items: center;
    padding: 0.8rem 1rem;
    cursor: pointer;
    transition: 0.3s all;
    &:hover {
      background-color: rgba(255, 255, 255, 0.06);
    }
    &.collapsed {
      border-top: none;
    }
    h3 {
      font-size: 1.2rem;
      margin: 0;
      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.WHITE};
      font-size: 1rem;
      transition: 0.3s all;
    }
    svg {
      color: ${({ theme }) => theme.COLORS.WHITE};
      transition: transform 0.3s ease;
    }
  }
`;

export const ExpandableSection = styled.div<{ $isExpanded: boolean }>`
  width: 100%;
  display: grid;
  grid-template-rows: ${({ $isExpanded }) => ($isExpanded ? '1fr' : '0fr')};
  transition: grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  > div {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    ${({ $isExpanded, theme }) =>
      $isExpanded &&
      css`
        border-radius: 8px;
        border-bottom: 0.2px solid ${transparentize(0.7, theme.COLORS.GREEN_20)};
        margin-bottom: 0.4rem;
        padding-bottom: 0.4rem;
      `}
  }
`;
